
import { Select, Option } from "element-ui"
import _ from "lodash"
import filterBar from "./filterBar.vue"
import storeMap from "./storeMap.vue"
import { getClickCollectStores } from "@/api/delivery"
import { getComm, getStoreInfo } from "@/api/comm"
import { setCookies, getDeliveryMethod } from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"

const ITEM_SIZE = 124
const MAX_CLIENT_WIDTH = 1360

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    filterBar,
    storeMap
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      isFullMap: false,
      currentPosition: {}, // 当前定位
      searchValue: "",
      itemSize: 124,
      storeList: [], // 全量数据
      filterStoreList: [], // 过滤筛选后的数据
      firstStore: {},
      activeItem: {},
      oldActiveItem: {}
    }
  },
  computed: {
    btnDisabled() {
      const { id } = this.activeItem
      const { id: compareId } = this.oldActiveItem

      if (getDeliveryMethod() === "homeDelivery" && id) {
        return false
      }
      if (!id) {
        return true
      }
      if (id && compareId && id === compareId) {
        return true
      }
      return false
    },
    noSearchResult() {
      return (!this.filterStoreList || !this.filterStoreList.length) && !!this.searchValue
    }
  },
  watch: {
    visible: {
      async handler(val) {
        if (val) {
          try {
            this.loading = true
            this.isFullMap = false
            this.currentPosition = {}
            this.searchValue = ""
            this.storeList = []
            this.filterStoreList = []
            this.activeItem = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
            this.oldActiveItem = _.cloneDeep(this.activeItem)
            this.clearFilter()
            await this.getStores()
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeItemSize, false)
    this.resizeItemSize()
    this.handleTriggerPosition()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeItemSize, false)
  },
  methods: {
    resizeItemSize: _.throttle(function () {
      const deviceWidth =
        document.documentElement.clientWidth >= MAX_CLIENT_WIDTH
          ? MAX_CLIENT_WIDTH
          : document.documentElement.clientWidth
      const scale = parseFloat(deviceWidth / MAX_CLIENT_WIDTH)
      this.itemSize = scale * ITEM_SIZE
    }, 100),
    handleTriggerPosition() {
      if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
        navigator.geolocation.getCurrentPosition(this.setLocation, () => {
          this.$message({
            type: "warning",
            message: this.$t("storeLocator.locationError")
          })
        })
      } else {
        console.log("Geolocation is not supported by this browser.")
      }
    },
    setLocation(position) {
      const { latitude } = position.coords
      const { longitude } = position.coords
      this.currentPosition = { latitude, longitude }
      console.log("this.currentPosition", this.currentPosition)
      // 清空筛选项
      this.clearFilter()
      // 根据当前经纬度获取附近门店
      this.getStores()
    },
    clearFilter() {
      this.searchValue = ""
      if (this.$refs.filterBar) {
        this.$refs.filterBar.clearFilter && this.$refs.filterBar.clearFilter()
      }
    },
    handleFilter(filterList = [], searchValue = "") {
      this.filterStoreList = _.cloneDeep(filterList)
      this.searchValue = _.cloneDeep(searchValue)
      this.scrollToElement(0)
    },
    async getStores() {
      try {
        this.loading = true
        const params = {}
        const { latitude, longitude } = this.currentPosition
        if (latitude) params.latitude = latitude
        if (longitude) params.longitude = longitude
        const { data: res } = await getClickCollectStores({ param: JSON.stringify(params) })
        this.storeList = res || []
        this.firstStore = this.storeList[0] || {}
        this.handleFilter(this.storeList, this.searchValue)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    isDisabled(item) {
      const availableCapacity = item.availableCapacity || 0
      return availableCapacity <= 0
    },
    isActive(item) {
      return this.activeItem.id && item.id && this.activeItem.id === item.id
    },
    toggleSelect(item) {
      if (this.isActive(item) || this.isDisabled(item)) return
      console.log("toggleSelect", item)
      this.activeItem = item
    },
    scrollToElement(index = 0) {
      this.$nextTick(() => {
        const scrollTop = this.itemSize * index
        const el = document.getElementById("virtual-scroller")
        if (el) {
          el.scrollTop = scrollTop
        }
      })
    },
    getIndex(id) {
      return this.filterStoreList.findIndex(item => item.id === id)
    },
    handleChangeCurrentStore(id) {
      const index = this.getIndex(id)
      if (index === -1) {
        // 当前点击的点不在filter列表中，直接选中
        const target = this.storeList.find(item => item.id === id) || {}
        this.toggleSelect(target)
      } else {
        // 当前点击的点在filter列表中，定位到该点并选中
        this.scrollToElement(index)
        console.log("index", index, this.filterStoreList[index])
        const target = this.filterStoreList[index] || {}
        this.toggleSelect(target)
      }
    },
    handleClose() {
      this.$emit("close")
    },
    async handleSave() {
      try {
        if (this.btnDisabled) return
        console.log("save", this.activeItem)

        const params = { shipmentType: 2, pickUpStoreId: this.activeItem.erpStoreId }
        const { data: res } = await getComm({ param: JSON.stringify(params) })

        const options = {}
        if (window.exp) {
          options.expires = window.exp
        }
        setCookies("pickUpStoreId", res.pickUpStoreId, options)
        setCookies("shipmentType", res.shipmentType, options)
        this.activeItem._locale = getLanguage()
        localStorage.setItem("curSelStore", JSON.stringify(this.activeItem))

        this.handleClose()
        setTimeout(() => {
          window.location.reload()
        }, 200)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
